import {
  Equal31pr842ymh8s6 as Equal,
  NotEqual3by2u1rdr6xhj as NotEqual,
  LessThan328qpp4kkt6qa as LessThan,
  GreaterThanOrEqual3ghjzsakr35no as GreaterThanOrEqual,
  LessThanOrEqual3o5tj78evuy34 as LessThanOrEqual,
  Inside34e21e5w7gmr5 as Inside,
  StringContains1bog4sdhgv5sy as StringContains,
  RawStringContains3pup1bkmqxswn as RawStringContains,
} from './Condition.mjs';
import { toSet2orjxp16sotqu as toSet } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { DataClassPathSelf18kqeagzkbefr as DataClassPathSelf } from './DataClassPath.mjs';
import { EmptySerializersModule991ju6pz9b79 as EmptySerializersModule } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/modules/SerializersModuleBuilders.mjs';
import { StringArrayFormat1xi667mcf8p4h as StringArrayFormat } from '../../../../../service-abstractions-data-shared/com/lightningkite/services/data/StringArrayFormat.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var f;
function eq(_this__u8e3s4, value) {
  _init_properties_ConditionBuilder_kt__m7iuao();
  return _this__u8e3s4.mapCondition_3hl8s3_k$(Equal().new_com_lightningkite_services_database_Condition_Equal_nldxtl_k$(value));
}
function neq(_this__u8e3s4, value) {
  _init_properties_ConditionBuilder_kt__m7iuao();
  return _this__u8e3s4.mapCondition_3hl8s3_k$(NotEqual().new_com_lightningkite_services_database_Condition_NotEqual_vy8bqe_k$(value));
}
function lt(_this__u8e3s4, value) {
  _init_properties_ConditionBuilder_kt__m7iuao();
  return _this__u8e3s4.mapCondition_3hl8s3_k$(LessThan().new_com_lightningkite_services_database_Condition_LessThan_vay77v_k$(value));
}
function gte(_this__u8e3s4, value) {
  _init_properties_ConditionBuilder_kt__m7iuao();
  return _this__u8e3s4.mapCondition_3hl8s3_k$(GreaterThanOrEqual().new_com_lightningkite_services_database_Condition_GreaterThanOrEqual_65340f_k$(value));
}
function lte(_this__u8e3s4, value) {
  _init_properties_ConditionBuilder_kt__m7iuao();
  return _this__u8e3s4.mapCondition_3hl8s3_k$(LessThanOrEqual().new_com_lightningkite_services_database_Condition_LessThanOrEqual_z59w3m_k$(value));
}
function xDataClassPathInsideSet(_this__u8e3s4, values) {
  _init_properties_ConditionBuilder_kt__m7iuao();
  return _this__u8e3s4.mapCondition_3hl8s3_k$(Inside().new_com_lightningkite_services_database_Condition_Inside_7n2d7w_k$(values));
}
function inside(_this__u8e3s4, values) {
  _init_properties_ConditionBuilder_kt__m7iuao();
  return _this__u8e3s4.mapCondition_3hl8s3_k$(Inside().new_com_lightningkite_services_database_Condition_Inside_7n2d7w_k$(toSet(values)));
}
function xDataClassPathContainsCased(_this__u8e3s4, value, ignoreCase) {
  _init_properties_ConditionBuilder_kt__m7iuao();
  return _this__u8e3s4.mapCondition_3hl8s3_k$(StringContains().new_com_lightningkite_services_database_Condition_StringContains_glssca_k$(value, ignoreCase));
}
function xDataClassPathContainsRawCased(_this__u8e3s4, value, ignoreCase) {
  _init_properties_ConditionBuilder_kt__m7iuao();
  return _this__u8e3s4.mapCondition_3hl8s3_k$(RawStringContains().new_com_lightningkite_services_database_Condition_RawStringContains_dkubqt_k$(value, ignoreCase));
}
function path(serializer) {
  _init_properties_ConditionBuilder_kt__m7iuao();
  return new (DataClassPathSelf())(serializer);
}
var properties_initialized_ConditionBuilder_kt_oyhlmm;
function _init_properties_ConditionBuilder_kt__m7iuao() {
  if (!properties_initialized_ConditionBuilder_kt_oyhlmm) {
    properties_initialized_ConditionBuilder_kt_oyhlmm = true;
    f = new (StringArrayFormat())(EmptySerializersModule());
  }
}
//region block: exports
export {
  xDataClassPathContainsCased as xDataClassPathContainsCased3loynnz3n7tb9,
  xDataClassPathContainsRawCased as xDataClassPathContainsRawCased39irduoqizpcd,
  eq as eq353yrgcpovoi1,
  gte as gte1zw995v5ulf70,
  inside as inside26mvda7ucvpq5,
  xDataClassPathInsideSet as xDataClassPathInsideSet2a49hafkm1zud,
  lte as lte2qmhlnwrclg8p,
  lt as lt30kf68e33bhtj,
  neq as neqpgb3jcwulnab,
  path as path1xmlqjtovoe0v,
};
//endregion

//# sourceMappingURL=ConditionBuilder.mjs.map
